'use strict';

const React = require('react');
const PropTypes = require('prop-types');

const TYPE_LIGHT = 'light';
const TYPE_DARK = 'dark';
const TYPE_TRANSPARENT = 'transparent';
const TYPE_COLORED = 'colored';

function SocialIcon(props) {
    const { Icon, iconName, iconType, ...other } = props;

    return (
        <div
            className={`svg-icon-wrapper social-button-${iconType} ${iconName}`}
            title={iconName}
            {...other}
        >
            <Icon className="social-icon" />
        </div>
    );
}

SocialIcon.defaultProps = {
    iconType: TYPE_LIGHT,
};

SocialIcon.propTypes = {
    Icon: PropTypes.func.isRequired,
    iconName: PropTypes.string.isRequired,
    iconType: PropTypes.oneOf([TYPE_LIGHT, TYPE_DARK, TYPE_TRANSPARENT, TYPE_COLORED]),
};

module.exports = SocialIcon;
module.exports.TYPE_LIGHT = TYPE_LIGHT;
module.exports.TYPE_DARK = TYPE_DARK;
module.exports.TYPE_TRANSPARENT = TYPE_TRANSPARENT;
module.exports.TYPE_COLORED = TYPE_COLORED;



// WEBPACK FOOTER //
// ./assets/js/global/components/SocialIcon/SocialIcon.jsx